import api from './api';

// Dashboard
export const getHome = (userData) =>
  api.post('/api/admin/getdashboard', userData)
    .then(r => r.data)
    .catch(error => {
      console.error('Dashboard fetch error:', error);
      throw error;
    });

// Users
export const getUsers = (userData) => {
  return api.post('/api/getusers', userData)
    .then(r => r.data)
    .catch(error => {
      console.error('Get users error:', error);
      throw error;
    });
};

export const getUsersClients = (queryParams) => {
  const { filter, search, page = 1, limit = 10, sort } = queryParams;
  const params = new URLSearchParams({
    page,
    limit,
    ...(filter && { filter }),
    ...(sort && { sort }),
    ...(search && { search }),
  });
  return api.get(`/api/admin/v2/clients?${params}`)
    .then(r => r.data)
    .catch(error => {
      console.error('Get user clients error:', error);
      throw error;
    });
};

export const getUsersDrivers = (queryParams) => {
  const { filter, search, page = 1, limit = 10, sort } = queryParams;
  const params = new URLSearchParams({
    page,
    limit,
    ...(filter && { filter }),
    ...(sort && { sort }),
    ...(search && { search }),
  });
  return api.get(`/api/admin/v2/drivers?${params}`)
    .then(r => r.data)
    .catch(error => {
      console.error('Get user drivers error:', error);
      throw error;
    });
};

export const getUser = (userId) =>
  api.post('/api/admin/getuser', { userId })
    .then(r => r.data)
    .catch(error => {
      console.error('Get user error:', error);
      throw error;
    });

export const setUser = (userData) =>
  api.post('/api/setuser', userData)
    .then(r => r.data)
    .catch(error => {
      console.error('Set user error:', error);
      throw error;
    });

export const getUserRecordsCount = (params) =>
  api.get('/api/admin/userRecordsCount', { params })
    .then(r => r.data)
    .catch(error => {
      console.error('Get user records count error:', error);
      throw error;
    });

// Quotes
export const setQuote = (quoteData) =>
  api.post('/api/setquote', quoteData)
    .then(r => r.data)
    .catch(error => {
      console.error('Set quote error:', error);
      throw error;
    });

export const forcePaymentCompleted = (quoteId) =>
  api.post('/api/admin/forcepaymentcompleted', { quoteId })
    .then(r => r.data)
    .catch(error => {
      console.error('Force payment completed error:', error);
      throw error;
    });

export const deleteAvatarsAPI = (userData) =>
  api.post('/api/deleteavatars', userData)
    .then(r => r.data)
    .catch(error => {
      console.error('Delete avatars error:', error);
      throw error;
    });

export const setJob = (jobData) =>
  api.post('/api/setjob', jobData)
    .then(r => r.data)
    .catch(error => {
      console.error('Set job error:', error);
      throw error;
    });
